import React, { useRef, useState } from 'react';
import { Portal } from 'react-portal';
import copyToClipboard from 'copy-to-clipboard';
import notification from 'helpers/notification';
import { useResponsive } from 'helpers/use_responsive';
import Icon from './icon';

interface ClipboardProps {
  children: any;
  text: string;
  textPrefix?: any;
}

const Clipboard = ({ text, children, textPrefix }: ClipboardProps) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const tooltipTimeout = useRef(null);
  const { isMobile } = useResponsive();

  const copy = () => {
    copyToClipboard(text);
    notification.success('Copied to clipboard');
  };

  const getCoords = () => {
    let top, left;
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      top = rect.top + window.scrollY - 30;
      left = rect.left + rect.width / 2;
    }

    return { top, left };
  };

  const handleMouseEnter = () => {
    if (tooltipTimeout.current) {
      clearTimeout(tooltipTimeout.current);
      tooltipTimeout.current = null;
    } else {
      tooltipTimeout.current = setTimeout(() => {
        setOpen(true);
        tooltipTimeout.current = null;
      }, 300);
    }
  };

  const handleMouseLeave = () => {
    if (tooltipTimeout.current) {
      clearTimeout(tooltipTimeout.current);
      tooltipTimeout.current = null;
    } else {
      tooltipTimeout.current = setTimeout(() => {
        setOpen(false);
        tooltipTimeout.current = null;
      }, 600);
    }
  };

  return (
    <span
      className="clipboard"
      onClick={() => setOpen(true)}
      ref={ref}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      {!isMobile && text && open && (
        <Portal>
          <div
            className="clipboard__tooltip"
            onClick={() => copy()}
            style={{ position: 'absolute', ...getCoords() }}
          >
            {textPrefix && <span className="clipboard__tooltip-text-prefix">{textPrefix}</span>}
            <span className="clipboard__tooltip-text">{text}</span>
            <Icon name="copy" width={16} height={16} />
          </div>
        </Portal>
      )}
    </span>
  );
};

export default Clipboard;
